import { store } from 'redux/store';
import { Operation } from 'types';
import { addDocumentToOperation } from 'modules/transactions/api/addDocumentToOperation';

type UpdateOperationDocumentsProps = {
  operation: Operation;
  newDocumentId: string;
};

export const updateOperationDocuments = async ({
  operation,
  newDocumentId,
}: UpdateOperationDocumentsProps) => {
  if (newDocumentId && operation?._id) {
    await store.dispatch(
      addDocumentToOperation({
        operationId: operation._id,
        documentId: newDocumentId,
      })
    );
  }
};
